/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth >= 1000) {
    const gallery = document.querySelector('.nytta-product-gallery');

    if (gallery) {
      gallery.classList.add('nytta-grid-active');
    }
  }
});

/* NYTTA — Navigation retour menu mobile */
document.addEventListener('click', function (event) {
  const backButton = event.target.closest('.nytta-menu-back');

  if (!backButton) return;

  event.preventDefault();
  event.stopPropagation();

  const currentPanel = backButton.closest('collapsible-content');

  if (!currentPanel) return;

  const trigger = document.querySelector(
    '[aria-controls="' + currentPanel.id + '"]'
  );
  if (trigger) {
  const whiteFade = document.createElement('div');

  whiteFade.style.position = 'absolute';
  whiteFade.style.inset = '0';
  whiteFade.style.background = '#ffffff';
  whiteFade.style.opacity = '0';
  whiteFade.style.zIndex = '9999';
  whiteFade.style.pointerEvents = 'none';
  whiteFade.style.transition = 'opacity 0.35s ease';

  currentPanel.appendChild(whiteFade);

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      whiteFade.style.opacity = '1';
    });
  });

  setTimeout(() => {
    currentPanel.ignoreNextTransition = true;
    trigger.click();

    whiteFade.style.transition = 'opacity 1.2s ease';
    whiteFade.style.opacity = '0';

    setTimeout(() => {
      whiteFade.remove();
    }, 1200);
  }, 350);
}
});

/* NYTTA - Synchronisation des points du carrousel mobile */
document.addEventListener('scroll', function(event) {
  const gallery = event.target;

  if (!gallery.classList ||
      !gallery.classList.contains('nytta-mobile-gallery')) {
    return;
  }

  const dots = gallery.parentElement.querySelectorAll(
    '.nytta-gallery-dot'
  );

  if (!dots.length || !gallery.clientWidth) return;

  const activeIndex = Math.round(
    gallery.scrollLeft / gallery.clientWidth
  );

  dots.forEach(function(dot, index) {
    dot.classList.toggle('is-active', index === activeIndex);
  });
}, true);


/* NYTTA - Synchroniser les pastilles avec les photos */
document.addEventListener('change', function(event) {
  const input = event.target;

  if (!input.matches('.product-item .color-swatch__radio')) {
    return;
  }

  const card = input.closest('.product-item');
  const gallery = card?.querySelector('.nytta-mobile-gallery');
  const mediaId = input.getAttribute('data-variant-featured-media');

  if (!gallery || !mediaId) return;

  const slides = Array.from(
    gallery.querySelectorAll('.nytta-mobile-gallery__slide')
  );

  const index = slides.findIndex(function(slide) {
    return slide.getAttribute('data-media-id') === mediaId;
  });

  if (index < 0) return;

  gallery.scrollTo({
    left: slides[index].offsetLeft - slides[0].offsetLeft,
    behavior: 'smooth'
  });
});


/* NYTTA - Défilement souris des photos collections */
(function () {
  let drag = null;
  let blockClick = null;

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    if (window.innerWidth < 768) return;

    const wrapper = event.target.closest('.product-item__image-wrapper');
    const gallery = wrapper?.querySelector('.nytta-mobile-gallery');

    if (!gallery) return;

    drag = {
      gallery: gallery,
      wrapper: wrapper,
      startX: event.clientX,
      initialScroll: gallery.scrollLeft,
      moved: false
    };
  }, true);

  document.addEventListener('pointermove', function (event) {
    if (!drag) return;

    const distance = event.clientX - drag.startX;

    if (Math.abs(distance) > 6) {
      if (!drag.moved) {
        drag.moved = true;
        drag.gallery.style.scrollSnapType = 'none';
      }

      event.preventDefault();
      drag.gallery.scrollLeft = drag.initialScroll - distance;
    }
  }, true);

  document.addEventListener('pointerup', function () {
    if (!drag) return;

    const gallery = drag.gallery;

    if (drag.moved) {
      blockClick = drag.wrapper;

      const width = gallery.clientWidth;

      gallery.style.scrollSnapType = '';

      if (width > 0) {
        const index = Math.round(gallery.scrollLeft / width);

        gallery.scrollTo({
          left: index * width,
          behavior: 'smooth'
        });
      }
    }

    drag = null;
  }, true);

  document.addEventListener('pointercancel', function () {
    if (drag) {
      drag.gallery.style.scrollSnapType = '';
    }
    drag = null;
  }, true);

  document.addEventListener('click', function (event) {
    if (blockClick && blockClick.contains(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    blockClick = null;
  }, true);

  document.addEventListener('dragstart', function (event) {
    if (event.target.closest('.product-item__image-wrapper')) {
      event.preventDefault();
    }
  }, true);
})();

/* NYTTA - Fleches galerie collection ordinateur */
(function () {
  function initNyttaArrows() {
    document.querySelectorAll('.nytta-mobile-gallery').forEach(function (gallery) {
      const slides = gallery.querySelectorAll('.nytta-mobile-gallery__slide');
      const container = gallery.closest('.product-item__aspect-ratio');

      if (!container || slides.length < 2) return;
      if (container.querySelector('.nytta-desktop-arrows')) return;

      const arrows = document.createElement('div');
      arrows.className = 'nytta-desktop-arrows';

      arrows.innerHTML = `

<button type="button" class="nytta-desktop-arrow nytta-prev" aria-label="Photo précédente">&#8249;</button>
<button type="button" class="nytta-desktop-arrow nytta-next" aria-label="Photo suivante">&#8250;</button>

      `;

      container.appendChild(arrows);

      arrows.addEventListener('pointerdown', function (e) {
        e.stopPropagation();
      }, true);

      arrows.addEventListener('click', function (e) {
        const button = e.target.closest('button');
        if (!button) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const width = gallery.clientWidth;
        if (!width) return;

        const current = Math.round(gallery.scrollLeft / width);
        const direction = button.classList.contains('nytta-next') ? 1 : -1;
        const next = Math.max(0, Math.min(slides.length - 1, current + direction));

        gallery.scrollTo({
          left: next * width,
          behavior: 'smooth'
        });
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNyttaArrows);
  } else {
    initNyttaArrows();
  }

  document.addEventListener('shopify:section:load', initNyttaArrows);
})();
